import {memo} from 'react'
import {Alert, AlertTitle, AlertDescription} from '@/shared/ui'

interface RoomErrorStateProps {
  message: string
}

export const RoomErrorState = memo(function RoomErrorState({message}: RoomErrorStateProps) {
  return (
    <div
      className="flex min-h-0 flex-1 flex-col items-center justify-center p-4"
      style={{
        background:
          'linear-gradient(to bottom right, var(--error-state-from), var(--error-state-to))',
      }}
    >
      <div className="flex w-full max-w-md flex-col items-center gap-4">
        <Alert variant="error">
          <AlertTitle>Ошибка подключения</AlertTitle>
          <AlertDescription>{message}</AlertDescription>
        </Alert>
      </div>
    </div>
  )
})
